export default __webpack_public_path__ + "static/media/Loaf_iPhoneX_Home_Screen_11_19_21.d459e48f.png";